import React from "react";
import { connect, useDispatch } from "react-redux";
import { loadingSelector, opportunitiesSelector } from "reducers";
import { showModal, selectOpportunity } from "actions";
import Table, { currencyCell, dateCell, notesCell } from "components/table";
import IconLink from "../../components/IconLink";
import { FaEdit, FaTrash } from "react-icons/fa";
import { DELETE_OPPORTUNITY_MODAL, OPPORTUNITY_MODAL } from "../../components/modals";

const OpportunitiesTable = ({ opportunities, ...props }) => {
  let columns = [
    {
      Header: "Action",
      Cell: ({ row }) => {
        return (
          <>
            <IconLink
              Icon={FaEdit}
              iconConfig={{ className: "table--action-icon" }}
              tooltip="View/Edit"
              onClick={() => {
                props.selectOpportunity(row.original.id);
                props.showModal(OPPORTUNITY_MODAL);
              }}
            />
            <IconLink
              Icon={FaTrash}
              iconConfig={{ className: "table--action-icon red" }}
              tooltip="Delete"
              onClick={() => {
                props.selectOpportunity(row.original.id);
                props.showModal(DELETE_OPPORTUNITY_MODAL, { id: row.original.id });
              }}
            />
          </>
        );
      },
    },
    {
      Header: "Account",
      accessor: "account_name",
      sortType: () => null,
      Cell: ({ row }) => {
        const accountId = row.original.account_id;
        if (accountId) {
          return (
            <div className="text-wrap">
              <a href={`/accounts/${accountId}/information/`} target="_blank" rel="noreferrer">
                {row.original.account_name}
              </a>
            </div>
          );
        }
        return "";
      },
    },
    {
      Header: "Status",
      accessor: "status",
    },
    {
      Header: "Sales Rep",
      accessor: "sales_representative_name",
    },
    {
      Header: "National Account",
      accessor: "national_account_name",
    },
    {
      Header: "Insured Names",
      accessor: "insured_names",
    },
    {
      Header: "Insured Ages",
      accessor: "insured_ages",
    },
    {
      Header: "Policy Number",
      accessor: "policy_number",
    },
    {
      Header: "Carrier",
      accessor: "carrier_name",
    },
    {
      Header: "Product Type",
      accessor: "product_type",
    },
    {
      Header: "Insured Lives",
      accessor: "number_of_insured_lives",
    },
    {
      Header: "Face Amount",
      accessor: "face_amount",
      Cell: currencyCell,
    },
    {
      Header: "Create Date",
      accessor: "date_created",
      Cell: dateCell,
    },
    {
      Header: "Last Edit Date",
      accessor: "last_edit_date",
      Cell: dateCell,
    },
    {
      Header: "Notes",
      accessor: "notes",
      Cell: notesCell,
    },
  ];

  let tableClass = "";
  if (opportunities.length > 1) {
    tableClass = "tableFixed";
  }

  return (
    <Table
      columns={columns}
      data={opportunities}
      defaultSort={true}
      paginated={false}
      emptyMessage={props.loading?.opportunities ? "Loading Opportunity data..." : "No data"}
      initialPageSize={100}
      tableClass={tableClass}
      sortBy={[{ id: "date_created", desc: true }]}
    />
  );
};

const mapStateToProps = (state, ownProps) => {
  return {
    opportunities: opportunitiesSelector(state),
    loading: loadingSelector(state),
  };
};

export default connect(mapStateToProps, {
  showModal,
  selectOpportunity,
})(OpportunitiesTable);
